"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputEntitySelect = exports.InputEntitySelect = exports.InputEntitySelectComponent = exports.InputEntitySelectDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var lodash_1 = require("lodash");
var theme_1 = require("@shapeable/theme");
var to_array_1 = require("../../utils/to-array");
var use_lang_1 = require("../../hooks/use-lang");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var react_highlight_words_1 = __importDefault(require("react-highlight-words"));
var sprintf_js_1 = require("sprintf-js");
var input_select_1 = require("./input-select");
var entity_select_1 = require("../entities/entity-select");
var entity_form_route_1 = require("../entities/entity-form-route");
var lodash_2 = require("lodash");
var icon_button_1 = require("../elements/icon-button");
var field_container_1 = require("../elements/field-container");
var client_1 = require("@apollo/client");
exports.InputEntitySelectDefaultProps = {
  loading: false,
  isSearchable: true,
  isClearable: true,
  isMulti: false,
  options: []
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InputSelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: 8px;\n  "], ["\n    padding-bottom: 8px;\n  "])))
});
var CreateContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n  "], ["\n    display: flex;\n    align-items: center;\n  "])))
});
var CreateButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    text-transform: capitalize;\n  "], ["\n    text-transform: capitalize;\n  "])))
});
var OrCreateStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n    text-transform: uppercase;\n    color: ", ";\n    font-size: ", ";\n    margin-right: ", ";\n  "], ["\n    position: relative;\n    text-transform: uppercase;\n    color: ", ";\n    font-size: ", ";\n    margin-right: ", ";\n  "])), theme_1.theme.COLOR('text-subtle'), theme_1.theme.FONT_SIZE(12), theme_1.theme.UNIT(2))
});
var EntitySelectStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    display: flex;\n    align-items: flex-end;\n    margin-top: ", ";\n    padding: 2px 0 1px 12px;\n    border-left: 2px solid ", ";\n    margin-left: 1px;\n  "], ["\n    display: flex;\n    align-items: flex-end;\n    margin-top: ", ";\n    padding: 2px 0 1px 12px;\n    border-left: 2px solid ", ";\n    margin-left: 1px;\n  "])), theme_1.theme.UNIT(2.5), theme_1.theme.COLOR('line-subtle'))
});
// -------- Functions -------->
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  InputSelect: (0, styled_components_1.default)(input_select_1.InputSelect)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), InputSelectStyles),
  // deprecate this
  EntitySelect: (0, styled_components_1.default)(entity_select_1.EntitySelect)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), EntitySelectStyles),
  Controls: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  CreateContainer: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), CreateContainerStyles),
  CreateButton: (0, styled_components_1.default)(icon_button_1.CreateIconButton)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), CreateButtonStyles),
  OrCreate: styled_components_1.default.span(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), OrCreateStyles)
};
var InputEntitySelectComponent = function (props) {
  var className = props.className,
    field = props.field,
    isMulti = props.isMulti,
    onChange = props.onChange,
    context = props.context,
    entityTypeName = props.entityTypeName,
    isOptionDisabled = props.isOptionDisabled,
    variant = props.variant,
    loadOptionsFilter = props.loadOptionsFilter;
  if (!field) {
    throw new Error('InputSelect requires a field specification.');
  }
  if (!entityTypeName) {
    throw new Error("Entity Select cannot be created. Missing entity name.");
  }
  var name = field.name,
    valid = field.valid,
    focus = field.focus;
  var t = (0, use_lang_1.useLang)();
  var currentUserCan = context.currentUserCan,
    fieldState = context.fieldState,
    showModal = context.showModal,
    hideModal = context.hideModal,
    patchEntityData = context.patchEntityData,
    _a = context.entityData,
    entityData = _a === void 0 ? {
      name: ''
    } : _a;
  // const metadata = field.metadata || {};
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var parentConfig = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(context.entityTypeName);
  var metadata = __assign(__assign({}, field.metadata || {}), {
    parent: {
      type: parentConfig.label,
      name: fieldState && fieldState.name && fieldState.name.value
    }
  });
  var initialOptions = (0, lodash_1.filter)(__spreadArray(__spreadArray(__spreadArray([], __read(metadata.cacheOptions || []), false), __read((metadata.prefill || []).map(function (item) {
    return definition.select.transform(item, __assign(__assign({}, context), {
      definition: definition,
      variant: variant
    }));
  })), false), __read(field.name && (0, to_array_1.toArray)(entityData[field.name]).map(function (item) {
    return definition.select.transform(item, __assign(__assign({}, context), {
      definition: definition,
      variant: variant
    }));
  }) || []), false));
  var multiValue = (0, to_array_1.toArray)(field.value);
  var optionValue = isMulti ? multiValue.map(function (item) {
    var opt = initialOptions.find(function (option) {
      return option.value === item;
    });
    return opt;
  }) : initialOptions.find(function (option) {
    return option.value === field.value;
  }) || '';
  var _b = __read(React.useState(optionValue), 2),
    value = _b[0],
    setValue = _b[1];
  // this is a workaround for problems with rendering up the chain, which would require a full rewrite of the forms code.
  React.useEffect(function () {
    setValue(optionValue);
  }, [entityData]);
  var client = (0, client_1.useApolloClient)();
  var canCreateCheck = props.canCreate || definition.select.canCreate;
  var canCreate = !field.disabled && !field.disallowCreate && canCreateCheck && canCreateCheck({
    currentUserCan: currentUserCan
  });
  var createLabel = (0, sprintf_js_1.sprintf)(t(definition.create.newLabel), definition.label);
  var afterSelect = canCreate && React.createElement(My.CreateContainer, null, React.createElement(My.OrCreate, null, t('or')), React.createElement(My.CreateButton, {
    gap: "6px",
    iconSize: 16,
    onClick: function () {
      onCreateOption('');
    }
  }, createLabel));
  var formatCreateLabel = function (inputValue) {
    return (0, sprintf_js_1.sprintf)("Add %s ".concat(inputValue ? 'named %s' : ''), definition.label, inputValue);
  };
  var noOptionsMessage = function (_a) {
    var inputValue = _a.inputValue;
    if (!inputValue) {
      return null;
    }
    return React.createElement(react_highlight_words_1.default, {
      searchWords: [inputValue],
      textToHighlight: (0, sprintf_js_1.sprintf)("Cannot find a %s matching %s", definition.label, inputValue)
    });
  };
  var onCreateOption = function (inputValue) {
    showModal(React.createElement(entity_form_route_1.EntityCreateFormRoute, {
      metadata: metadata,
      initialFieldState: {
        name: {
          value: inputValue
        },
        slug: {
          value: (0, lodash_2.kebabCase)(inputValue)
        }
      },
      isModal: true,
      onSubmit: function (entity) {
        var _a;
        // patch the currently displayed entity data
        // this is assumed to be the addition of the new entity under the current field's name
        var patch = (_a = {}, _a["".concat(field.name)] = [entity], _a);
        patchEntityData(patch, function () {
          // add the new item to the actual value - this is assumed to be the current set of ids plus the newly created item
          var createdValue = entity.id;
          var newValue = isMulti ? __spreadArray(__spreadArray([], __read(field.value), false), [createdValue], false) : createdValue;
          onChange({
            name: field.name,
            value: newValue,
            client: context.client
          });
          var newOption = definition.select.transform(entity, context);
          setValue(isMulti ? __spreadArray(__spreadArray([], __read((0, to_array_1.toArray)(value)), false), [newOption], false) : newOption);
          hideModal();
        });
      },
      onCancel: function () {
        return hideModal();
      },
      definition: definition
    }), entityTypeName);
  };
  var emptyFunc = function () {
    return null;
  };
  var handleChange = function (info) {
    var value = isMulti ? (info || []).map(function (option) {
      return option.value;
    }) : info && info.value || '';
    var cacheOptions = field.metadata && field.metadata.cacheOptions || [];
    var newCacheOptions = (0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], __read(cacheOptions), false), __read((0, to_array_1.toArray)(info)), false), function (option) {
      return option.value;
    });
    onChange({
      name: field.name,
      client: client,
      value: value,
      metadata: {
        cacheOptions: newCacheOptions
      }
    });
    setValue(info);
  };
  return React.createElement(My.Container, {
    field: field
  }, React.createElement(My.EntitySelect, {
    onChange: handleChange,
    showEditMenu: canCreate,
    value: value,
    maxMenuHeight: field.maxMenuHeight,
    noOptionsMessage: noOptionsMessage,
    isOptionDisabled: isOptionDisabled,
    isMulti: isMulti,
    entityTypeName: entityTypeName
  }), React.createElement(My.Controls, null, afterSelect));
};
exports.InputEntitySelectComponent = InputEntitySelectComponent;
exports.InputEntitySelectComponent.defaultProps = exports.InputEntitySelectDefaultProps;
exports.InputEntitySelect = (0, styled_components_1.withTheme)(exports.InputEntitySelectComponent);
var createInputEntitySelect = function (props) {
  return React.createElement(exports.InputEntitySelect, __assign({}, props));
};
exports.createInputEntitySelect = createInputEntitySelect;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;